import { type MaybeRefOrGetter } from 'vue'

import { useLibraryQueryStore } from '../stores/library.query-store'

export const useLibrary = (locationId: MaybeRefOrGetter<string>) => {
  const queryStore = useLibraryQueryStore(locationId)

  const fetchAllProducts = queryStore.fetchAllProductsQuery

  const fetchUpsellProducts = queryStore.fetchUpsellProductsQuery

  return {
    fetchAllProducts,
    fetchUpsellProducts,
  }
}
